'use client';

import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { useEnvironmentInfo } from '~/hooks';
import { AppDownloadBXArea } from './AppDownloadBXArea';
import styles from './BasicLayout.module.css';
import { useSearchParams } from 'next/navigation';
import { OverlayProvider as BgztOverlayProvider } from '@bgzt/ui';

export const ROOT_ELEMENT_ID = 'root';
export const CONTENTS_AREA_ELEMENT_ID = 'contents-area';
type Props = {
  isBot?: boolean;
};
export const BasicLayout = ({ children, isBot = false }: PropsWithChildren<Props>) => {
  const { isWebview } = useEnvironmentInfo();

  const searchParams = useSearchParams();
  const shouldHideAppNudge = searchParams.get('hide-app-nudge') === 'true';

  return (
    <BgztOverlayProvider>
      <main id={ROOT_ELEMENT_ID} className={clsx([styles.container, { isWebview }])}>
        <div className={styles.contents}>
          <section id={CONTENTS_AREA_ELEMENT_ID} className={styles.layout}>
            {children}
          </section>
          {!isWebview && !shouldHideAppNudge && !isBot && <AppDownloadBXArea />}
        </div>
      </main>
    </BgztOverlayProvider>
  );
};
